import Footer from './Footer';

import './Footer.css';

export default Footer;
